import PropTypes from 'prop-types';
import React from 'react';

import GenericFormItem from '../GenericFormItem';

const CheckboxList = function CheckboxList(props) {
  const {
    val,
    label,
  } = props;
  const mappedVal = val.map(item => (
    <div className="uk-grid" key={item[1]}>
      <div className="uk-width-medium-3-5 uk-width-mobile-2-3">
        {item[1]}
      </div>
    </div>
  ));
  return (
    <GenericFormItem label={label}>
      {mappedVal}
    </GenericFormItem>
  );
};

CheckboxList.propTypes = {
  val: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.string,
};

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/CheckboxList.js